/* hh-megamenu.js — 260711
   Desktop (>=992px): open the mega menu on HOVER instead of requiring a click.
   Click still works (the theme's dropdown-component owns the state — we just drive it),
   and keyboard/focus behaviour is untouched.

   The panel is a DOM child of the <li>, so moving the pointer from the nav item down into
   the panel does NOT fire mouseleave on the <li>. The close delay only has to cover the
   visual gap between the nav row and the panel edge. */
(function () {
  var OPEN_DELAY = 60;   /* small, so it feels instant but ignores a pointer just passing through */
  var CLOSE_DELAY = 180; /* long enough to cross the gap between nav row and panel */

  function isDesktop() {
    return window.matchMedia('(min-width: 992px)').matches;
  }

  function bind(li) {
    if (li.__hhHoverBound) return;
    var opener = li.querySelector('.main-navigation_dropdown-opener');
    if (!opener) return;
    li.__hhHoverBound = true;

    var timer;

    li.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (opener.getAttribute('aria-expanded') === 'false') opener.click();
      }, OPEN_DELAY);
    });

    li.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (opener.getAttribute('aria-expanded') === 'true') opener.click();
      }, CLOSE_DELAY);
    });
  }

  function init() {
    document
      .querySelectorAll('.main-navigation--desktop .main-navigation_item.--mega-menu-active')
      .forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
